import styled, { css } from 'styled-components';
import { applyStyleModifiers } from 'styled-components-modifiers';
import { media, rem, themed } from '@/shared/ui/core';

const modifiers = {
  withNotification: ({ theme }) => ({
    styles: `
      &::before {
        content: " ";
        width: 0.75rem;
        height: 0.75rem;
        background-color: ${theme.primary.main};
        border-radius: 100%;
        display: block;
        position: absolute;
        top: 1.25rem;
        right: 0;
        transform: translate(-50%,-50%);

        @media ${media.desktopMin} {
          top: -0.55rem;
          right: auto;
          left: 3.6rem;
        }
      }
    `,
  }),
};

const NavBottom = styled.nav.attrs({
  className: 'NavBottom',
})`
  list-style: none;
  background-color: white;
  width: 100%;
  height: ${rem(90)};
  padding: 0;
  margin: 0;
  border-top: ${rem(4)} solid #F4F6F6;
  display: flex;
  justify-content: center;
  z-index: 1;

  @media ${media.desktopMin} {
    width: 21rem;
    height: auto;
    border-top: none;
    border-radius: 0.25rem;
    background-color: transparent;
    overflow: hidden;
  }
`;

const Wrapper = styled.ul.attrs({
  className: 'NavBottom__Wrapper',
})`
  width: 100%;
  max-width: ${rem(380)};
  display: flex;
  justify-content: space-around;
  padding: 0;
  margin: 0;

  @media ${media.desktopMin} {
    width: 100%;
    height: auto;
    padding: 1.25rem 0;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
`;

const Item = styled.li.attrs({
  className: 'NavBottom__Item',
})`
  width: ${rem(55)};
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  cursor: pointer;
  ${applyStyleModifiers(modifiers)}

  ${({ active }) => active && css`
    &::after {
      background-color: ${themed('primary.main')};
      width: 100%;
      height: ${rem(10)};
      border-top-left-radius: ${rem(4)};
      border-top-right-radius: ${rem(4)};
      content: "";
      position: absolute;
      bottom: 0;

      @media ${media.desktopMin} {
        height: 100%;
        max-height: 0.65rem;
        max-width: 80%;
        border-radius: 2px;
        top: -1.5rem;
        bottom: auto;
        left: 50%;
        transform: translate(-44%,-50%);
      }
    }
  `}

  a {
    text-decoration: none;

    @media ${media.desktopMin} {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
    }
  }

  @media ${media.desktopMin} {
    width: 100%;
    height: 20%;
    max-height: 2.5rem;
    padding-left: 0.5rem;
  }
`;

const ItemIcon = styled.div.attrs({
  className: 'NavBottom__ItemIcon',
})`
  height: ${rem(35)};
  display: flex;
  align-items: center;
  justify-content: center;

  svg path {
    fill: ${themed('nav.color')};
  }

  @media ${media.desktopMin} {
    margin-right: 0.125rem;
    width: 3rem;
    display: none;

    svg path {
      fill: transparent;
    }
  }
`;

const ItemName = styled.div.attrs({
  className: 'NavBottom__ItemName',
})`
  .Text {
    font-weight: 500;
    text-align: center;
    color: ${themed('nav.color')};
    font-size: ${themed('nav.fontSize', rem)};
  }

  @media ${media.desktopMin} {
    .Text {
      font-size: 1rem;
    }
  }
`;

NavBottom.Wrapper = Wrapper;
NavBottom.Item = Item;
NavBottom.ItemIcon = ItemIcon;
NavBottom.ItemName = ItemName;

export { NavBottom };
